import AuthLayout from "layout/AuthLayout";
import { Outlet } from "react-router-dom";

const AuthHolder = () => {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default AuthHolder;
